export var VERSION = '2.11.6';
//# sourceMappingURL=version.js.map